import { useCallback, useEffect, useState } from 'react';
import { ChevronUp } from '@bridebook/aura/src/icons';
import { Button } from '@bridebook/aura';
import debounce from 'lodash/debounce';

export const FloatingScrollButton = () => {
  const [showButton, setShowButton] = useState(false);

  const handleClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    const onScrollEnd = debounce(() => {
      const show = window.scrollY > 0;
      setShowButton(show);
    }, 200);

    const onScroll = () => {
      setShowButton(false);
      onScrollEnd();
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      onScrollEnd.cancel();
    };
  }, []);

  return (
    <Button
      icon={ChevronUp}
      variant="secondary"
      size="lg"
      className={`fixed right-4 bottom-[calc(16px+env(safe-area-inset-bottom))] z-500 shadow-bb-shadow transition-opacity duration-200 ${
        showButton ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      onClick={handleClick}
    />
  );
};
